import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseDashboardStats, PurchaseDashboardState } from "../../../types/dashboard/purchaseDashboardInterfaces";

// ✅ Estado inicial
const initialState: PurchaseDashboardState = {
    stats: {
        totalPurchases: 0,
        purchasesByStatus: {},
        purchasesByDocumentType: {},
        purchasesBySupplier: {},
        purchasesByBranch: {},
        purchasesByMonth: {},
    },
};

export const purchaseDashboardSlice = createSlice({
    name: "purchaseDashboard",
    initialState,
    reducers: {
        /**
         * 📊 Carga las estadísticas correctamente.
         */
        setStats: (state, action: PayloadAction<IPurchaseDashboardStats>) => {
            state.stats = action.payload;
        },

        /**
         * 🔄 Permite limpiar el estado si se requiere.
         */
        clearStats: (state) => {
            state.stats = {
                totalPurchases: 0,
                purchasesByStatus: {},
                purchasesByDocumentType: {},
                purchasesBySupplier: {},
                purchasesByBranch: {},
                purchasesByMonth: {},
            };
        },
    },
});

export const { setStats, clearStats } = purchaseDashboardSlice.actions;
export default purchaseDashboardSlice.reducer;
